import { Input } from './Input';
import { InputHTMLAttributes } from 'react';
import {
  formatCep,
  formatCnpj,
  formatCpf,
  formatPhone,
  MASKS,
} from '@/design-system/utils/masks';

type MaskType = keyof typeof MASKS;

const formatters: Record<MaskType, (v: string) => string> = {
  CNPJ: formatCnpj,
  CPF: formatCpf,
  CEP: formatCep,
  PHONE: formatPhone,
  CELL: formatPhone,
};

interface MaskedInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  label?: string;
  error?: string;
  mask: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Ignorado (não repassado ao DOM) - compatibilidade com API anterior */
  maskChar?: string | null;
}

export function MaskedInput({
  label,
  error,
  mask,
  value,
  onChange,
  className,
  maskChar: _maskChar,
  ...props
}: MaskedInputProps) {
  const maskKey = Object.keys(MASKS).find((k) => MASKS[k as MaskType] === mask) as MaskType | undefined;
  const format = maskKey ? formatters[maskKey] : (v: string) => v;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const formatted = format(raw);
    e.target.value = formatted;
    onChange(e);
  };

  return (
      <Input
        {...props}
        label={label}
        error={error}
        value={value}
        onChange={handleChange}
        className={className}
      />
  );
}
